import { render } from "./ContactView.vue?vue&type=template&id=c8cbdcee&scoped=true"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import "./ContactView.vue?vue&type=style&index=0&id=c8cbdcee&scoped=true&lang=css"

import exportComponent from "/Users/tom/Projects/GitHub/contact-details/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cbdcee"]])

export default __exports__